const CHANNEL_NAME = 'ciq:promptOverridesChanged';

type Listener = () => void;

const listeners = new Set<Listener>();

let channel: BroadcastChannel | null = null;

const getChannel = (): BroadcastChannel | null => {
  if (typeof BroadcastChannel === 'undefined') return null;
  if (!channel) {
    channel = new BroadcastChannel(CHANNEL_NAME);
    channel.addEventListener('message', () => listeners.forEach((listener) => listener()));
  }
  return channel;
};

/**
 * Announce that this user's prompt overrides changed — created, edited, activated or turned off.
 *
 * Prompt Lab and the AI shell are separate React trees that never share state: the shell is a
 * global drawer, Prompt Lab is a route, and the banner's "View" opens it in a new tab. Both cases
 * need covering, so this goes over a BroadcastChannel for other tabs and straight to the local
 * listeners for this one.
 */
export const notifyPromptOverridesChanged = (): void => {
  // BroadcastChannel deliberately never echoes to the object that posted, and both trees in one
  // tab share this module's single channel — so same-tab listeners have to be called directly.
  getChannel()?.postMessage(CHANNEL_NAME);
  listeners.forEach((listener) => listener());
};

export const subscribeToPromptOverrideChanges = (onChange: Listener): (() => void) => {
  getChannel();
  listeners.add(onChange);
  return () => {
    listeners.delete(onChange);
  };
};
